import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Languages, Wrench } from 'lucide-react';

export function Translator() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
      <Link
        to="/dashboard"
        className="inline-flex items-center text-[--text-secondary] hover:text-[--text-primary] mb-8"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back
      </Link>

      <div className="mb-6 sm:mb-8">
        <div className="flex justify-between items-center">
          <h1 className="text-xl sm:text-2xl font-bold text-[--text-primary]">
            Translator
          </h1>
        </div>
        <p className="mt-2 text-sm sm:text-base text-[--text-secondary]">
          Advanced translation services for academic and professional documents.
        </p>
      </div>

      <div className="bg-[--bg-primary] rounded-lg shadow p-8 sm:p-12">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <Languages className="h-16 w-16 text-[--text-disabled]" />
              <Wrench className="h-6 w-6 text-warning-500 absolute -bottom-1 -right-1" />
            </div>
          </div>
          
          <h2 className="text-2xl font-bold text-[--text-primary] mb-4">
            Under Construction
          </h2>
          
          <p className="text-[--text-secondary] mb-6 max-w-md mx-auto">
            We're working hard to bring you powerful translation capabilities. 
            This feature will be available soon with support for multiple languages 
            and specialized academic terminology.
          </p>
          
          <div className="bg-[--bg-secondary] rounded-lg p-4 max-w-lg mx-auto">
            <h3 className="text-lg font-semibold text-[--text-primary] mb-2">
              Coming Soon
            </h3>
            <ul className="text-sm text-[--text-secondary] space-y-1">
              <li>• Multi-language document translation</li>
              <li>• Academic terminology preservation</li>
              <li>• Citation format maintenance</li>
              <li>• Real-time collaboration</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}